import LegalLayout from './LegalLayout';
import { legalConfig } from './legalConfig';

export default function PrivacyPage() {
  return (
    <LegalLayout title="Chính sách bảo mật">
      <p className="mb-3">
        Chính sách này mô tả cách {legalConfig.company} thu thập, sử dụng và bảo vệ thông tin của bạn
        khi bạn sử dụng ứng dụng <strong>EBD Learning</strong> trên iOS, Android, Windows, macOS và
        các dịch vụ trực tuyến đi kèm tại tên miền <code>ebdlearning.vn</code>.
      </p>

      <p className="mb-3">
        Bằng việc tạo tài khoản hoặc sử dụng ứng dụng, bạn đồng ý với các nội dung được nêu dưới đây.
        Nếu bạn không đồng ý, vui lòng ngừng sử dụng dịch vụ.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        1. Thông tin chúng tôi thu thập
      </h2>

      <h3 className="mt-6 mb-2 text-[17px] font-semibold">1.1. Thông tin tài khoản</h3>
      <ul className="mb-3 list-disc space-y-1.5 pl-6">
        <li>Họ và tên, địa chỉ email, mật khẩu (được lưu ở dạng băm, chúng tôi không lưu mật khẩu gốc).</li>
        <li>Số điện thoại, địa chỉ và phần giới thiệu bản thân — chỉ khi bạn tự nhập.</li>
        <li>Thông tin trường học, lớp học và vai trò (học sinh, giáo viên, quản lý) để phân quyền truy cập.</li>
      </ul>
      <p className="mb-3">
        Với tài khoản học sinh do nhà trường tạo, thông tin tài khoản do nhà trường cung cấp cho chúng tôi
        trong phạm vi phục vụ hoạt động dạy và học.
      </p>

      <h3 className="mt-6 mb-2 text-[17px] font-semibold">1.2. Thông tin thiết bị</h3>
      <p className="mb-3">
        Ứng dụng đăng ký thiết bị với hệ thống nhằm giới hạn số thiết bị được dùng trên một tài khoản và
        bảo vệ bản quyền nội dung. Chúng tôi lưu:
      </p>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-[15px]">
          <thead>
            <tr>
              <th className="border border-slate-200 p-2.5 text-left align-top bg-slate-50 font-semibold dark:border-slate-700 dark:bg-slate-800">
                Dữ liệu
              </th>
              <th className="border border-slate-200 p-2.5 text-left align-top bg-slate-50 font-semibold dark:border-slate-700 dark:bg-slate-800">
                Mục đích
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Mã định danh thiết bị do hệ điều hành cấp
              </td>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Phân biệt các thiết bị của cùng một tài khoản
              </td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Tên thiết bị, kiểu máy, nền tảng, phiên bản hệ điều hành
              </td>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Hiển thị danh sách thiết bị để bạn nhận biết và quản lý
              </td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Phiên bản ứng dụng, thời điểm hoạt động gần nhất
              </td>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Hỗ trợ kỹ thuật và phát hiện đăng nhập bất thường
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="mb-3">
        Mã định danh này do hệ điều hành cung cấp cho riêng ứng dụng và <strong>không phải</strong> mã
        quảng cáo; chúng tôi không dùng nó cho mục đích quảng cáo hay theo dõi bạn trên ứng dụng khác.
      </p>

      <h3 className="mt-6 mb-2 text-[17px] font-semibold">1.3. Dữ liệu học tập</h3>
      <ul className="mb-3 list-disc space-y-1.5 pl-6">
        <li>Tiến độ đọc sách, trang đang đọc, ghi chú và đánh dấu trang bạn tạo trong ứng dụng.</li>
        <li>Kết quả làm bài tập, bài kiểm tra và bài tập được giao.</li>
        <li>Danh sách sách trong thư viện của bạn và mã kích hoạt sách đã sử dụng.</li>
      </ul>
      <p className="mb-3">
        Dữ liệu này được lưu trên thiết bị để dùng khi không có mạng, đồng thời đồng bộ lên máy chủ để bạn
        tiếp tục học trên thiết bị khác.
      </p>

      <h3 className="mt-6 mb-2 text-[17px] font-semibold">1.4. Dữ liệu kỹ thuật và báo cáo sự cố</h3>
      <p className="mb-3">
        Khi ứng dụng gặp lỗi, chúng tôi gửi báo cáo sự cố tới dịch vụ giám sát Sentry, bao gồm thông tin
        lỗi, kiểu thiết bị, phiên bản hệ điều hành và phiên bản ứng dụng. Ứng dụng được cấu hình
        <strong> không đính kèm ảnh chụp màn hình</strong> và <strong>không tự động gửi thông tin nhận dạng
        cá nhân</strong> kèm báo cáo lỗi.
      </p>

      <h3 className="mt-6 mb-2 text-[17px] font-semibold">1.5. Những gì chúng tôi không thu thập</h3>
      <ul className="mb-3 list-disc space-y-1.5 pl-6">
        <li>Không thu thập vị trí địa lý.</li>
        <li>Không truy cập danh bạ, tin nhắn, lịch sử cuộc gọi.</li>
        <li>Không sử dụng mã quảng cáo, không hiển thị quảng cáo trong ứng dụng.</li>
        <li>Không bán, không trao đổi dữ liệu người dùng cho bên thứ ba vì mục đích thương mại.</li>
      </ul>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        2. Quyền truy cập thiết bị
      </h2>
      <p className="mb-3">Ứng dụng chỉ yêu cầu quyền khi bạn chủ động sử dụng tính năng tương ứng:</p>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-[15px]">
          <thead>
            <tr>
              <th className="border border-slate-200 p-2.5 text-left align-top bg-slate-50 font-semibold dark:border-slate-700 dark:bg-slate-800">
                Quyền
              </th>
              <th className="border border-slate-200 p-2.5 text-left align-top bg-slate-50 font-semibold dark:border-slate-700 dark:bg-slate-800">
                Dùng để làm gì
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">Máy ảnh</td>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Quét mã QR để kích hoạt sách hoặc tham gia lớp học. Ảnh không được lưu lại hay gửi đi.
              </td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Bộ nhớ / tệp
              </td>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Tải và lưu sách để đọc khi không có kết nối mạng.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="mb-3">
        Bạn có thể từ chối hoặc thu hồi các quyền này trong cài đặt hệ điều hành; khi đó tính năng tương ứng sẽ ngừng hoạt động.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        3. Mục đích sử dụng thông tin
      </h2>
      <ul className="mb-3 list-disc space-y-1.5 pl-6">
        <li>Cung cấp và duy trì tài khoản, xác thực đăng nhập.</li>
        <li>Cấp quyền truy cập sách và học liệu bạn đã được cấp phép.</li>
        <li>Lưu và đồng bộ tiến độ học tập giữa các thiết bị của bạn.</li>
        <li>Báo cáo kết quả học tập cho giáo viên, nhà trường hoặc phụ huynh có liên quan trực tiếp tới người học.</li>
        <li>Bảo vệ bản quyền nội dung, phát hiện và ngăn chặn việc chia sẻ tài khoản trái phép.</li>
        <li>Khắc phục sự cố và cải thiện chất lượng ứng dụng.</li>
      </ul>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        4. Lưu trữ và bảo mật
      </h2>
      <ul className="mb-3 list-disc space-y-1.5 pl-6">
        <li>Dữ liệu được lưu trên hạ tầng máy chủ đặt tại khu vực Singapore (Amazon Web Services).</li>
        <li>Mọi kết nối giữa ứng dụng và máy chủ được mã hoá bằng giao thức HTTPS/TLS.</li>
        <li>Mật khẩu được lưu ở dạng băm một chiều.</li>
        <li>Nội dung sách tải về được mã hoá trên thiết bị và chỉ giải mã được bằng tài khoản đã được cấp phép.</li>
        <li>Phiên đăng nhập được lưu trong kho lưu trữ an toàn của hệ điều hành trên thiết bị của bạn.</li>
      </ul>
      <div className="my-5 rounded-md border border-slate-200 border-l-[3px] border-l-blue-700 bg-slate-50 p-4 dark:border-slate-700 dark:border-l-blue-400 dark:bg-slate-800">
        Không có hệ thống nào an toàn tuyệt đối. Vui lòng giữ kín mật khẩu và thông báo cho chúng tôi ngay
        khi phát hiện tài khoản bị truy cập trái phép.
      </div>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        5. Chia sẻ thông tin với bên thứ ba
      </h2>
      <p className="mb-3">Chúng tôi chỉ chia sẻ dữ liệu trong các trường hợp sau:</p>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-[15px]">
          <thead>
            <tr>
              <th className="border border-slate-200 p-2.5 text-left align-top bg-slate-50 font-semibold dark:border-slate-700 dark:bg-slate-800">
                Bên nhận
              </th>
              <th className="border border-slate-200 p-2.5 text-left align-top bg-slate-50 font-semibold dark:border-slate-700 dark:bg-slate-800">
                Dữ liệu
              </th>
              <th className="border border-slate-200 p-2.5 text-left align-top bg-slate-50 font-semibold dark:border-slate-700 dark:bg-slate-800">
                Lý do
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Amazon Web Services
              </td>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Toàn bộ dữ liệu ứng dụng (lưu trữ, phân phối nội dung)
              </td>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Nhà cung cấp hạ tầng máy chủ và mạng phân phối nội dung
              </td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">Sentry</td>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Báo cáo lỗi, thông tin thiết bị và phiên bản ứng dụng
              </td>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Giám sát và khắc phục sự cố kỹ thuật
              </td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Nhà trường, giáo viên, phụ huynh
              </td>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Kết quả và tiến độ học tập của người học liên quan
              </td>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Phục vụ hoạt động dạy, học và theo dõi của gia đình
              </td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Cơ quan nhà nước có thẩm quyền
              </td>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Theo phạm vi yêu cầu
              </td>
              <td className="border border-slate-200 p-2.5 text-left align-top dark:border-slate-700">
                Khi có yêu cầu hợp pháp theo quy định pháp luật Việt Nam
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        6. Thời gian lưu trữ
      </h2>
      <p className="mb-3">
        Chúng tôi lưu dữ liệu tài khoản và dữ liệu học tập trong suốt thời gian tài khoản còn hoạt động.
        Khi tài khoản bị xoá theo yêu cầu, dữ liệu cá nhân sẽ được xoá hoặc ẩn danh trong vòng 30 ngày,
        trừ phần dữ liệu phải lưu lâu hơn theo quy định pháp luật hoặc theo thoả thuận với nhà trường.
        Báo cáo lỗi kỹ thuật được lưu tối đa 90 ngày.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        7. Quyền của bạn
      </h2>
      <ul className="mb-3 list-disc space-y-1.5 pl-6">
        <li>Xem và chỉnh sửa thông tin cá nhân trong mục Hồ sơ của ứng dụng.</li>
        <li>Đổi mật khẩu bất kỳ lúc nào.</li>
        <li>Yêu cầu bản sao dữ liệu cá nhân mà chúng tôi đang lưu.</li>
        <li>Yêu cầu xoá tài khoản và dữ liệu liên quan.</li>
        <li>Rút lại sự đồng ý bằng cách ngừng sử dụng và yêu cầu xoá tài khoản.</li>
      </ul>
      <p className="mb-3">
        Để thực hiện các quyền trên, gửi yêu cầu tới{' '}
        <a className="text-blue-700 dark:text-blue-400" href={`mailto:${legalConfig.email}`}>
          {legalConfig.email}
        </a>
        . Chúng tôi phản hồi trong vòng 15 ngày làm việc. Với tài khoản do nhà trường cấp, chúng tôi có thể
        cần xác nhận từ nhà trường trước khi xử lý.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        8. Thông tin của trẻ em
      </h2>
      <p className="mb-3">
        EBD Learning được sử dụng trong môi trường giáo dục, trong đó có người học dưới 16 tuổi. Tài khoản
        của các em thường do nhà trường tạo và quản lý với sự đồng ý của nhà trường và gia đình. Chúng tôi
        chỉ thu thập thông tin tối thiểu cần cho việc học, không dùng dữ liệu của trẻ em cho mục đích
        quảng cáo hay tiếp thị. Cha mẹ hoặc người giám hộ có thể liên hệ với chúng tôi hoặc với nhà trường
        để xem, chỉnh sửa hoặc yêu cầu xoá dữ liệu của con em mình.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        9. Thay đổi chính sách
      </h2>
      <p className="mb-3">
        Chúng tôi có thể cập nhật chính sách này khi tính năng hoặc quy định pháp luật thay đổi. Bản mới
        nhất luôn được đăng tại trang này kèm ngày hiệu lực. Với thay đổi quan trọng, chúng tôi sẽ thông
        báo trong ứng dụng hoặc qua email trước khi áp dụng.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        10. Liên hệ
      </h2>
      <p className="mb-3">
        {legalConfig.company}
        <br />
        Mã số doanh nghiệp: {legalConfig.taxCode}
        <br />
        Địa chỉ: {legalConfig.address}
        <br />
        Email:{' '}
        <a className="text-blue-700 dark:text-blue-400" href={`mailto:${legalConfig.email}`}>
          {legalConfig.email}
        </a>
        <br />
        Điện thoại: {legalConfig.phone}
      </p>
    </LegalLayout>
  );
}
